import PhoneVerificationModal from './PhoneVerificationModal.component';

export default PhoneVerificationModal;